import React from "react";

export const Titan = () => {
  return (
    <div>
      <div
        id={"titan"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};